// General
import "./verified-profile-description-dialog.scss";
import { useEffect } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateVerifiedProfileDescriptionDialog } from "../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import { Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// i18next
import { useTranslation } from "react-i18next";
// Custom Hooks
import IconManager from "../../../utility/manager/icon-manager/icon-manager";
import AssetManager from "../../../utility/manager/asset-manager/asset-manager";

const VerifiedProfileDescriptionDialog = () => {
  // Redux variables
  const verifiedProfileDescriptionDialog = useSelector(
    (state) => state.dialog.verifiedProfileDescriptionDialog
  );
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const getIcon = IconManager();
  const getAsset = AssetManager();

  // Lifecycle | Mounted
  useEffect(() => {
    if (!verifiedProfileDescriptionDialog) return;

    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-D30",
      },
    });
  }, [verifiedProfileDescriptionDialog]);

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateVerifiedProfileDescriptionDialog(false));
  };

  return (
    <Dialog
      className="custom-radius25-dialog"
      open={verifiedProfileDescriptionDialog}
      onClose={onCloseDialog}
    >
      <div id="verified-profile-description-dialog">
        <div className="dialog-header">
          <div className="close-button-container">
            <CloseIcon className="close-button" onClick={onCloseDialog} />
          </div>
        </div>

        <div className="padding-container">
          <div className="verified-profile-title-container">
            <div className="verified-profile-title">
              {t("popup.verified_profile_title")}
            </div>
            <div className="verified-profile-badge-container">
              {getIcon("verifiedProfileBadge", "verified-profile-badge")}
            </div>
          </div>

          <div className="verified-profile-description">
            {t("popup.verified_profile_desc")}
          </div>

          <div className="verified-checkbox-container">
            <div className="face-check-container">
              <img src={getAsset("greenTickOutlineIcon")} />
              {t("verification.stepper.liveness_check")}
            </div>

            <div className="photo-match-container">
              <img src={getAsset("greenTickOutlineIcon")} />
              {t("verification.stepper.photo_match_check")}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default VerifiedProfileDescriptionDialog;
